/**
 *
 * Organizations/Show
 *
 */

import React, { memo } from 'react'

// NPM Librarie
import PropTypes from 'prop-types'
import { Link, useLocation } from 'react-router-dom'

// Components
import Campaigns from 'components/Organizations/Show/Campaigns'
import CampaignTemplate from 'components/Organizations/Show/CampaignTemplates'
import ContactSms from 'components/Organizations/Show/ContactSms'
import Events from 'components/Organizations/Show/Events'
import ErrorBoundary from 'components/ErrorBoundary'
import Integrations from './Integrations'
import Settings from 'components/Organizations/Show/Settings'
import Sequences from 'components/Organizations/Show/Sequences'
import TabsBar from 'components/TabsBar'
import Tabs from 'components/Tabs'
import OptIns from 'components/Organizations/Show/OptIns'
import OrganizationEmailPreferences from 'components/EmailPreferences/Organizations'
import Users from 'components/Organizations/Show/Users'

import { queryVariables } from 'components/utils'

function Organization({ org }) {
	const location = useLocation()

	const tab_param = queryVariables(location).tab ? `#${queryVariables(location).tab}` : ''
	const hash = location.hash.length ? location.hash : tab_param

	if (org.is_ready_made_handler)
		return (
			<div>
				<p className="ml-2">
					This Ready-Made Handler contains the default email and SMS content for 567 Topics. The content found
					here is actively used for all 567 Campaigns. Any changes made will apply across all relevant Users
					and Campaigns throughout LeadJig.
				</p>
				<div>
					<TabsBar index={hash}>
						<Link to="#event-567-timeline">
							<span>Performance-Based Timeline</span>
						</Link>

						<Link to="#sequences">
							<span>Sequences</span>
						</Link>
					</TabsBar>

					<Tabs index={hash} virtualized>
						<ErrorBoundary tab_index="#event-567-timeline">
							<OrganizationEmailPreferences organization_id={org.id} category="event_567" hide_switches />
						</ErrorBoundary>

						<ErrorBoundary tab_index="#sequences">
							<Sequences organization_id={org.id} />
						</ErrorBoundary>
					</Tabs>
				</div>
			</div>
		)

	return (
		<div>
			<div>
				<TabsBar index={hash}>
					<Link to="#users">
						<span>Users</span>
					</Link>
					<Link to="#campaigns">
						<span>Campaigns</span>
					</Link>
					<Link to="#events">
						<span>Events</span>
					</Link>
					<Link to="#settings">
						<span>Settings and Disclaimers</span>
					</Link>
					<Link to="#event-timeline">
						<span>Custom-Crafted Timeline</span>
					</Link>
					<Link to="#event-567-timeline">
						<span>Performance-Based Timeline</span>
					</Link>
					<Link to="#appointment-timeline">
						<span>Appointments Timeline</span>
					</Link>
					<Link to="#campaign_templates">
						<span>Campaign Templates</span>
					</Link>
					<Link to="#opt_ins">
						<span>Opt-Ins</span>
					</Link>
					<Link to="#integrations">
						<span>Integrations</span>
					</Link>
				</TabsBar>

				<Tabs index={hash} virtualized>
					<ErrorBoundary tab_index="#users">
						<Users organization={org} />
					</ErrorBoundary>

					<ErrorBoundary tab_index="#campaigns">
						<Campaigns organization_id={org.id} />
					</ErrorBoundary>

					<ErrorBoundary tab_index="#events">
						<Events organization={org} />
					</ErrorBoundary>

					<ErrorBoundary tab_index="#settings">
						<Settings organization={org} />
					</ErrorBoundary>

					<ErrorBoundary tab_index="#campaign_templates">
						<CampaignTemplate organization={org} />
					</ErrorBoundary>

					<ErrorBoundary tab_index="#integrations">
						<Integrations organization_id={org.id} />
					</ErrorBoundary>

					<ErrorBoundary tab_index="#event-567-timeline">
						<OrganizationEmailPreferences organization_id={org.id} category="event_567" />
					</ErrorBoundary>

					<ErrorBoundary tab_index="#event-timeline">
						<OrganizationEmailPreferences organization_id={org.id} category="event" />
					</ErrorBoundary>

					<ErrorBoundary tab_index="#appointment-timeline">
						<OrganizationEmailPreferences organization_id={org.id} category="appointment" />
					</ErrorBoundary>

					<ErrorBoundary tab_index="#opt_ins">
						<OptIns organization_id={org.id} />
					</ErrorBoundary>

					<ErrorBoundary tab_index="#sms">
						<ContactSms organization_id={org.id} />
					</ErrorBoundary>
				</Tabs>
			</div>
		</div>
	)
}

Organization.propTypes = {
	org: PropTypes.object,
}

Organization.defaultProps = {
	org: {},
}

export default memo(Organization)
